import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15865_2037)">
      <g clipPath="url(#clip1_15865_2037)">
        <path
          d="M10.9971 25.0937C10.731 25.0937 10.4759 24.988 10.2878 24.7999C10.0996 24.6118 9.99395 24.3566 9.99395 24.0906V21.0906C9.98044 20.9513 9.9962 20.8108 10.0402 20.678C10.0843 20.5452 10.1556 20.4231 10.2496 20.3195C10.3436 20.2159 10.4583 20.1332 10.5862 20.0765C10.7141 20.0199 10.8525 19.9906 10.9924 19.9906C11.1323 19.9906 11.2706 20.0199 11.3986 20.0765C11.5265 20.1332 11.6411 20.2159 11.7352 20.3195C11.8292 20.4231 11.9005 20.5452 11.9445 20.678C11.9886 20.8108 12.0043 20.9513 11.9908 21.0906V24.0906C11.9908 24.355 11.8864 24.6088 11.7003 24.7966C11.5142 24.9845 11.2615 25.0912 10.9971 25.0937Z"
          fill="var(--tlx-color-azure-blue-400)"
        />
        <path
          d="M15.0002 25.0938C14.7341 25.0938 14.479 24.9881 14.2909 24.7999C14.1028 24.6118 13.9971 24.3567 13.9971 24.0906V20.0969C14.0211 19.8488 14.1367 19.6185 14.3213 19.451C14.5059 19.2834 14.7462 19.1906 14.9955 19.1906C15.2448 19.1906 15.4851 19.2834 15.6697 19.451C15.8543 19.6185 15.9699 19.8488 15.9939 20.0969V24.1C15.9915 24.3628 15.886 24.6141 15.7002 24.8C15.5143 24.9858 15.263 25.0913 15.0002 25.0938Z"
          fill="var(--tlx-color-azure-blue-400)"
        />
        <path
          d="M19.0029 25.0937C18.7369 25.0937 18.4817 24.9881 18.2936 24.7999C18.1055 24.6118 17.9998 24.3567 17.9998 24.0906V18.1C17.9863 17.9607 18.0021 17.8202 18.0461 17.6874C18.0901 17.5546 18.1614 17.4325 18.2555 17.3289C18.3495 17.2253 18.4641 17.1426 18.5921 17.0859C18.72 17.0293 18.8583 17 18.9982 17C19.1381 17 19.2765 17.0293 19.4044 17.0859C19.5323 17.1426 19.647 17.2253 19.741 17.3289C19.835 17.4325 19.9064 17.5546 19.9504 17.6874C19.9944 17.8202 20.0102 17.9607 19.9967 18.1V24.1C19.9942 24.3628 19.8888 24.6141 19.7029 24.8C19.5171 24.9858 19.2657 25.0913 19.0029 25.0937Z"
          fill="var(--tlx-color-azure-blue-400)"
        />
        <path
          d="M22.9969 30H7.00313C5.94144 30 4.92323 29.5782 4.17249 28.8275C3.42176 28.0768 3.00001 27.0586 3.00001 25.9969V7.875C2.99887 7.14136 3.1596 6.4165 3.47073 5.7521C3.78186 5.0877 4.23574 4.50012 4.80001 4.03125L8.25001 1.1625C9.14768 0.414436 10.2784 0.00327453 11.4469 0L22.9969 0C24.0586 0 25.0768 0.421757 25.8275 1.17249C26.5782 1.92322 27 2.94143 27 4.00313V25.9969C27 27.0586 26.5782 28.0768 25.8275 28.8275C25.0768 29.5782 24.0586 30 22.9969 30ZM11.4469 1.99688C10.7611 2.0077 10.0996 2.25246 9.57188 2.69062L6.07501 5.56875C5.73669 5.85017 5.46465 6.20278 5.27829 6.60143C5.09193 7.00008 4.99584 7.43494 4.99688 7.875V25.9969C4.99935 26.5257 5.21052 27.0322 5.58448 27.4062C5.95843 27.7801 6.46491 27.9913 6.99376 27.9938H22.9969C23.5257 27.9913 24.0322 27.7801 24.4062 27.4062C24.7801 27.0322 24.9913 26.5257 24.9938 25.9969V4.00313C24.9913 3.47428 24.7801 2.9678 24.4062 2.59385C24.0322 2.21989 23.5257 2.00872 22.9969 2.00625L11.4469 1.99688Z"
          fill="var(--tlx-color-azure-blue-400)"
        />
      </g>
      <g clipPath="url(#clip2_15865_2037)">
        <path
          d="M14.2873 6.60836L10.7582 12.5C10.6854 12.626 10.6469 12.7689 10.6465 12.9144C10.6461 13.0599 10.6838 13.203 10.7558 13.3294C10.8279 13.4558 10.9318 13.5612 11.0572 13.635C11.1826 13.7088 11.3252 13.7484 11.4707 13.75H18.529C18.6745 13.7484 18.817 13.7088 18.9424 13.635C19.0679 13.5612 19.1718 13.4558 19.2438 13.3294C19.3159 13.203 19.3536 13.0599 19.3532 12.9144C19.3528 12.7689 19.3143 12.626 19.2415 12.5L15.7123 6.60836C15.638 6.4859 15.5335 6.38466 15.4087 6.31439C15.2839 6.24413 15.143 6.20721 14.9998 6.20721C14.8566 6.20721 14.7158 6.24413 14.591 6.31439C14.4662 6.38466 14.3616 6.4859 14.2873 6.60836Z"
          stroke="var(--tlx-status-error-text)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 8.75V10.4167"
          stroke="var(--tlx-status-error-text)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 12.0833H15.0042"
          stroke="var(--tlx-status-error-text)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_15865_2037">
        <rect width="30" height="30" fill="var(--tlx-surface-bg-surface)" />
      </clipPath>
      <clipPath id="clip1_15865_2037">
        <rect width="30" height="30" fill="var(--tlx-surface-bg-surface)" />
      </clipPath>
      <clipPath id="clip2_15865_2037">
        <rect
          width="10"
          height="10"
          fill="var(--tlx-surface-bg-surface)"
          transform="translate(10 5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
